<template>
  <div class="mt-5 desktop:w-1/2">
    <template v-if="isCN">
      <figure v-if="isDesktop" class="relative aspect-video overflow-hidden">
        <img
          :src="provideImgUrl(partnership.pcPartnerImg)"
          alt="partnership"
          loading="lazy"
          class="pointer-events-none absolute left-0 top-0 h-full w-full object-cover"
        />
      </figure>

      <div v-else class="flex flex-wrap items-center justify-evenly">
        <div
          v-for="partner in contextPartners"
          :key="partner.name"
          class="w-[32%] tablet:w-[19%]"
        >
          <figure class="relative aspect-video w-full overflow-hidden">
            <img
              :src="provideImgUrl(partner.url)"
              :alt="partner.name"
              loading="lazy"
              class="pointer-events-none absolute left-0 top-0 h-full w-full object-cover"
            />
          </figure>
        </div>
      </div>
    </template>

    <figure v-else class="relative aspect-video overflow-hidden">
      <img
        :src="provideImgUrl(partnership.pcPartnerImg)"
        alt="partnership"
        loading="lazy"
        class="pointer-events-none absolute left-0 top-0 h-full w-full object-cover"
      />
    </figure>
  </div>
</template>

<script setup lang="ts">
  import type { IPartnerLogo, IPartnership } from '@/assets/types/Home';

  interface IProps {
    partnership: IPartnership;
  }

  const props = withDefaults(defineProps<IProps>(), {
    partnership: () => ({
      sectionTitle: '',
      btnOne: '',
      btnOneUrl: '',
      btnTwo: '',
      btnTwoUrl: '',
      pcPartnerImg: '',
      highlightPartners: [],
    }),
  });

  const { provideImgUrl } = useHomeData();
  const { isMobile, isDesktop } = useScreen();
  const { isCN } = useLanguage();

  const contextPartners = computed((): IPartnerLogo[] => {
    const partners = props.partnership.highlightPartners ?? [];
    return isMobile.value ? partners.slice(0, 9) : partners;
  });
</script>
